import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  width: 100%;
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 16px;
`;

export const ItemContainer = styled.div`
  width: calc(50% - 8px);
  color: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  background-color: transparent;
  padding: 16px;
`;
